export default __webpack_public_path__ + "static/media/veil.24586f07.png";